import React, { useCallback } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Outlet } from 'react-router-dom';

export const PrivateRouteElement = () => {
  const { keycloak, initialized } = useKeycloak();

  const login = useCallback(() => {
    keycloak.login();
  }, [keycloak]);

  if (!initialized) {
    return null;
  }

  if (keycloak.authenticated) {
    return <Outlet />;
  }

  keycloak.login();
  // Calling keycloak.login() should redirect browser to the login form.

  // If for some reason automatic redirect does not happen, let user perform
  // redirection by clicking.
  return (
    <p>
      Redirecting to login,{' '}
      <button type="button" style={{ verticalAlign: 'baseline' }} onClick={login}>
        click here
      </button>
      , if you are not redirected automatically.
    </p>
  );
};
